// TODO: Probably should move this to a namespaced module
export default {
  state: {
    time: Date(),
  },

  mutations: {
    updateTime(state) {
      state.time = new Date()
    },

    setIntervalID(state, interval) {
      state.interval = interval
    },
  },

  getters: {
    now: (state) => {
      return state.time
    },
  },

  actions: {
    startTrackingTime({ state, commit, dispatch }) {
      if (state.interval) {
        dispatch('stopTrackingTime')
      }

      const interval = setInterval(function () {
        commit('updateTime')
      }, 1000)
      commit('setIntervalID', interval)
    },

    stopTrackingTime({ state, commit }) {
      clearInterval(state.interval)
      commit('setIntervalID', undefined)
    },
  },
}
